import AOS from 'aos';

// AOS init
AOS.init({ once: true });